<template>
    <div>
      <!-- 詳細検索 -->
      <transition name="popup">
        <PCQASearchDetail
          v-if="state.visibleSearchDetail"
          :startLoading="state.visibleSearchDetail"
          :parentName="group1.parentName"
          @searchDetail="group1.searchDetail"
          @closeSearchDetail="state.visibleSearchDetail = false"
        />
      </transition>

      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack
          :action="props.historyBackAction"
         />
        <form @submit.prevent="group1.search" class="header-search" :class="group1.gaSearchClass">
          <template v-if="group1.isSearchDetail">
            <div class="header-search-title label">Q&amp;A・事例</div>
            <div @click="visibleSearchDetail" class="header-search-detail" role="button">
              <FontawesomeIcon :icon="['far','search']" size="2x" class="icn" />
              <span class="text">詳細検索の条件を変更する</span>
            </div>
          </template>
          <template v-else>
            <div class="header-search-title">
              <div class="formparts select"
                :class="{ 'is-visible-list': searchSelect.isFocusInput }"
                @mouseenter="searchSelect.isFocusInput = true"
                @mouseleave="searchSelect.isFocusInput = false"
              >
                <div class="select-label" role="select">{{ group1.searchCategoryName }}<FontawesomeIcon :icon="searchSelect.isFocusInput ? 'angle-up' : 'angle-down'" class="icn" /></div>
                <div class="select-option">
                  <ul class="select-option-list ta-left">
                    <li role="option"><label><input type="radio" v-on:change="group1.changeCategory" v-model="group1.searchCategory" value="qa" name="group_rd_02">Q&amp;A・事例</label></li>
                    <li v-if="!isFromAdminSystem()" role="option"><label><input type="radio" v-on:change="group1.changeCategory" v-model="group1.searchCategory" value="knowledge" name="group_rd_02">最新ナレッジ</label></li>
                    <li role="option"><label><input type="radio" v-on:change="group1.changeCategory" v-model="group1.searchCategory" value="book" name="group_rd_02">書籍目次</label></li>
                    <li role="option"><label><input type="radio" v-on:change="group1.changeCategory" v-model="group1.searchCategory" value="download" name="group_rd_02">書式ダウンロード</label></li>
                    <li v-if="!isFromAdminSystem()" role="option"><label><input type="radio" v-on:change="group1.changeCategory" v-model="group1.searchCategory" value="note" name="group_rd_02">ノート</label></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="header-search-input">
              <div class="formparts search mb0">
                <FontawesomeIcon @click="group1.search" :icon="['far','search']" size="2x" 
                  class="icn" :class="group1.gaSearchClass"
                />
                <input type="text" 
                  v-model="group1.search_text_input" 
                  @input="suggest.keyInput" 
                  @compositionend="suggest.keyInput"
                  v-click-outside="() => { suggest.displayTip = false }"
                  maxlength="50"
                  placeholder="キーワードを入力（最大50文字）">
                <div v-show="suggest.displayTip" class="tip">{{ suggest.fixedCount }}</div>
              </div>
            </div>
            <div class="header-search-config"
              v-if="group1.searchCategory !== 'download' && group1.searchCategory !== 'note'" 
            >
              <div class="header-search-config-item formparts checkbox mb0">
                <input type="checkbox" name="group_cb_04" id="is_fuzzy"
                  v-model.number="group1.is_fuzzy_input"
                  :true-value="0"
                  :false-value="1"
                >
                <label for="is_fuzzy" role="button">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
              </div>
            </div>
            <div class="header-search-link" v-if="searchSelect.currentValue === 0 && group1.searchCategory === 'qa'">
              <span role="button" class="header-search-link-text" @click="visibleSearchDetail">詳細検索</span>
            </div>
          </template>

          <template v-if="!isFromAdminSystem()">
            <div class="header-search-link"
              v-if="state.isOpenMenuArrow"
            >
              <router-link 
                v-if="group1.searchCategory === 'qa' || group1.searchCategory === 'knowledge'"
                to="/pc/search-condition-list" class="header-search-link-text">保存検索条件</router-link>
              <router-link 
                v-if="group1.searchCategory === 'qa' || group1.searchCategory === 'knowledge' || group1.searchCategory === 'note'"
                to="/pc/history-of-search" class="header-search-link-text">検索履歴</router-link>
            </div>
            <div class="header-search-arrow"
              v-if="group1.searchCategory === 'qa' || group1.searchCategory === 'knowledge' || group1.searchCategory === 'note'"
              @click="state.isOpenMenuArrow = !state.isOpenMenuArrow"
            >
              <FontawesomeIcon v-if="!state.isOpenMenuArrow" class="header-search-config-item icon" :icon="['fas','angle-right']" />
              <FontawesomeIcon v-else class="header-search-config-item icon" :icon="['fas','angle-left']" />
            </div>
            <template v-if="group1.isAlertShown">
              <router-link to="/pc/alert-list" class="header-search-alert">
                <FontawesomeIcon icon="bell" class="icn" />
                <span v-if="group1.alert_count_disp !== ''" class="num">{{ group1.alert_count_disp }}</span>
              </router-link>
            </template>
          </template>
        </form>
      </header>
      <!-- header:end -->
    </div>
</template>

<script>
import { defineComponent, reactive } from '@vue/composition-api'
import ClickOutside from 'vue-click-outside'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCQASearchDetail from '@/components/pc/popup/PCQASearchDetail.vue'

import * as logicSearchUI from '@/logic/common/SearchUI'
import { FixedHeader } from '@/logic/qa/FixedScrollHeader'
import { isFromAdminSystem } from '@/util/common'

export default defineComponent({
  name: 'PCSearchUI',
  directives: {
    ClickOutside
  },
  props: {
    // 呼び出している画面の種類
    // (dashboard:ダッシュボード、menu: メニュー、
    // qa:QA一覧、book:書籍一覧、download:書式DL一覧、
    // knowledge:最新ナレッジ一覧、note:ノート一覧)
    screenType: {
      type: String,
      default: '',
      required: true
    },
    // アラート表示フラグ
    isAlertShown: {
      type: Boolean,
      default: false
    },
    // 同画面でキーワード検索が実行されたか？
    // (1)キーワード入力欄でEnterを押した
    // (2)キーワード入力欄の検索ボタンを押した場合
    // ※他の画面から遷移してきた場合はfalse
    isSearchExecutedAtSameScreen: {
      type: Boolean,
      default: false
    },
    historyBackAction: {
      type: Function,
      default: null
    }
  },
  components: {
    PCMenu,
    PCQASearchDetail
  },
  setup (props, context) {

    const { group1, suggest, searchSelect } = logicSearchUI.getGroup(props, context)

    const state = reactive({
      visibleSearchDetail: false, // 詳細検索ウィンドウ表示フラグ
      isOpenMenuArrow: false
    })

    const disableScroll = (e) => {
      e.preventDefault()
    }

    const visibleSearchDetail = () => {
      document.addEventListener('touchmove', disableScroll, { passive: false })
      document.addEventListener('mousewheel', disableScroll, { passive: false })

      state.visibleSearchDetail = true

      setTimeout(() => {
        const fixedTitle = new FixedHeader({
          scroller: '.popup-wrapper',
          target: '.popup-title-fixed',
          wrapper: '.popup-fixed'
        })

        const fixedClose = new FixedHeader({
          scroller: '.popup-wrapper',
          target: '.close-fixed',
          type: 'absolute',
          offset: 12
        })

        document.removeEventListener('touchmove', disableScroll, { passive: false })
        document.removeEventListener('mousewheel', disableScroll, { passive: false })
      }, 500)
    }

    return {
      props,
      group1,
      state,
      suggest,
      visibleSearchDetail,
      searchSelect,
      isFromAdminSystem
    }
  }
})
</script>

<style lang="scss" scoped>
.header {
  &-search {
    &-title {
      padding-right: 10px;
      min-width: 230px;
      &.label {
        min-width: auto;
        text-align: center;
        padding: 0 20px;
        white-space: nowrap;
        font-size: 1.8rem;
      }
      .formparts.select {
        .select-label {
          color: #fff;
          font-size: bold;
          font-size: 1.8rem;
        }
        .select-option label {
          font-size: 1.6rem;
          color: $color-content;
        }
      }
    }
    &-alert {
      position: absolute;
      top: 20px;
      right: 40px;
      @include hoverOpacity;
      .icn {
        transform: rotate(45deg);
        margin-right: 5px;
      }
      .num {
        font-size: 1.4rem;
        color: $color-link;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #fff;
      }
    }
    &-detail {
      background-color: #fff;
      color: $color-link;
      border-radius: 4px;
      display: flex;
      align-items: center;
      height: 48px;
      padding: 0 20px;
      @include hoverOpacity();
      .icn {
        font-size: 1.8rem;
        margin-right: 10px;
      }
    }
  }
}
</style>
